import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import { LedgerStackParamList } from '../types/navigation';
import LedgerScreen from '../screens/LedgerScreen';
import LedgerDetailScreen from '../screens/ledger/LedgerDetailScreen';
import CreateLedgerAccountScreen from '../screens/ledger/CreateLedgerAccountScreen';
import AddEditLedgerEntryScreen from '../screens/ledger/AddEditLedgerEntryScreen';

const Stack = createStackNavigator<LedgerStackParamList>();

const LedgerNavigator: React.FC = () => {
  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: false,
      }}
    >
      <Stack.Screen name="LedgerHome" component={LedgerScreen} />
      <Stack.Screen 
        name="LedgerDetail" 
        component={LedgerDetailScreen}
        options={{
          presentation: 'card',
        }}
      />
      <Stack.Screen 
        name="CreateLedgerAccount" 
        component={CreateLedgerAccountScreen}
        options={{
          presentation: 'modal',
        }}
      />
      <Stack.Screen 
        name="AddEditLedgerEntry" 
        component={AddEditLedgerEntryScreen}
        options={{
          presentation: 'modal',
        }}
      />
    </Stack.Navigator>
  );
};

export default LedgerNavigator;
